import { Heading, Tag, TagLabel } from "@chakra-ui/react";
import clsx from "clsx";
import { format } from "date-fns";
import { Pin } from "lucide-react";
import React from "react";
import { PortfolioEmploymentHistoryItem } from "../../../types";
import { ExpandableText } from "features/jobs/expandable-text";
interface EmploymentHistoryItemProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  item: PortfolioEmploymentHistoryItem;
  editable?: boolean;
  pinned?: boolean;
  canPin?: boolean;
  onPinToggle?: () => void;
  isLoading?: boolean;
}

export function EmploymentHistoryItem({
  item,
  className,
  pinned,
}: EmploymentHistoryItemProps) {
  const { companyName, jobTitle, description, startedAt, endedAt } = item;

  const dateDisplay = () => {
    const startDate = format(new Date(startedAt), "MMM yyyy");
    if (endedAt === null) {
      return `${startDate} - Present`;
    }
    const endDate = format(new Date(endedAt), "MMM yyyy");
    return `${startDate} - ${endDate}`;
  };

  return (
    <>
      <div
        className={clsx(" grid grid-cols-[1fr,32px] border-b py-4", className)}
      >
        <div className={clsx("flex flex-col gap-4 ")}>
          <div className="flex flex-col gap-2 items-start">
            {pinned && (
              <Tag
                size="lg"
                display="flex"
                alignItems="center"
                borderRadius="full"
                colorScheme="flatteredFlamingo"
              >
                <Pin className="w-4 mr-2 rotate-45 fill-flatteredFlamingo-600" />
                <TagLabel fontWeight="500">Pinned</TagLabel>
              </Tag>
            )}
            <div className="flex flex-col lg:flex-row items-start lg:items-center gap-1">
              <Heading as="h4" fontSize={18} className="font-medium m-0">
                {jobTitle} at {companyName}
              </Heading>
            </div>

            <div className="flex flex-col lg:flex-row gap-1 lg:gap-4">
              <p>{dateDisplay()}</p>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            {description && <ExpandableText text={description} />}
          </div>
        </div>
      </div>
    </>
  );
}
